import axios from "axios";

import { endPoints } from "../../constant/api_constants/url";
import { ENDPOINT } from "../../constant/environment";
import { API_METHODS } from "../../enums";
import { decryptData, getHeaderConfig } from "../../utils/api/encryption";
import { fetchApi } from "../../utils/apiFunction";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";

export async function deleteHistoryAPI(id: string, accessJWT: string) {
  const URL = `${ENDPOINT}/app/v1/users/history/${id}`;

  if (id === "" || id === undefined) return;
  let config = getHeaderConfig(null, accessJWT);
  // let body = {
  //     email: email,
  //     password: password
  // }
  if (!hasUsableJWT(accessJWT, "deleteHistoryAPI")) return null;
  try {
    const response = await axios.delete(URL, config);
    const decryptedData = decryptData(response?.data);
    return decryptedData ? JSON.parse(decryptedData) : null;
    // return response?.data;
  } catch (error: any) {
    if (error.response && error.response.status === 409) {
      return null;
    }
    return null;
  }
}

export const deleteHistory = async (accessJWT: string, id: string, requestBody: any) => {
  const endpoint = endPoints.deleteHistory(id);

  return await fetchApi(accessJWT, endpoint, API_METHODS.DELETE, requestBody);
};
